import { API } from '.';

class SchoolService {
    async sendReport(schoolId, email) {
        try {
            const response = await API.post('/api/schools/weekly-report', {
                data: {
                    email: email,
                    schoolId: schoolId,
                },
            });
            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async update(schoolId, data = {}) {
        const response = await API.put(`/api/schools/${schoolId}`, {
            data,
        });
        return response.data;
    }
}

export default SchoolService;
